import { useEffect, useState } from 'react'


const useFetcherDataProvinces = () => {
  const [dataProvinces, setDataProvinces] = useState({})
  const [dataProvincesLoading, setDataProvincesLoading] = useState(true)

  const fetchData = (url) => {
    fetch(url)
      .then(res => res.json())
      .then(({ data }) => {
        setDataProvinces(data.filter(el => el.provinsi !== 'Indonesia'))
        setDataProvincesLoading(false)
      })
      .catch(err => {
        console.log(err)
      })
  }

  useEffect(() => {
    fetchData('https://indonesia-covid-19.mathdro.id/api/provinsi')
  }, [])

  return [dataProvinces, dataProvincesLoading]
}

export default useFetcherDataProvinces